import {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useTokenCache} from '@@client/lib/hooks'
import {getStampS} from '@@client/lib/dates'
import {getCreditCardKey} from './actions'

const getIsExpired = (creditCardKeyPayload, bufferSeconds = 180 /* 180s = 3m */) => {
    if(!creditCardKeyPayload) return false
    if(!creditCardKeyPayload.exp) return false

    const now = getStampS()

    return (now - bufferSeconds) > creditCardKeyPayload.exp
}

export default function loadCreditCardKey() {
    const dispatch = useDispatch()
    const tokenCache = useTokenCache()
    const config = useSelector(state => state.config)
    const checkoutStore = useSelector(state => state.checkout)

    const tokenIsExpired = getIsExpired(checkoutStore.info.creditCardKeyPayload)

    useEffect(() => {
        // credit cards disabled
        if(config.payments.creditCardPaymentUnavailable) return

        // already doing, no need to fetch again
        if(checkoutStore.creditCardKey.doing) return

        dispatch(getCreditCardKey(tokenCache))
    }, [
        tokenIsExpired, // if it is expired, then get a new one
        checkoutStore.info.checkoutToken,
        checkoutStore.info.salesTaxToken,
    ])

    return null
}
